app.component('dropboxUpload', {
    bindings: {
        show: '='
    },
    templateUrl: './App/Packages/DropboxUpload.html',
    controller: ['$scope', 'sessions', 'growl', '$location', 'packageService', '$routeParams',
        function ($scope, sessions, growl, $location, packageService, $routeParams) {
            var that = this;

            that.init = function () {
                that.session = sessions.getCurrent();
                that.dropboxLink = null;
                that.autoPublish = false;
                that.packageId = parseInt($routeParams.packageId, 10);
            };

            that.close = function () {
                that.show = false;
                that.dropboxLink = null;
                that.isUploading = false;
            }

            that.back = function () {
                that.close();
            }            

            that.saveDropboxUrl = function () {
                that.isUploading = true;

                var uploadRequest = {
                    PackageId: that.packageId,
                    DropboxUrl: that.dropboxLink,
                    AutoPublish: that.autoPublish
                };

                packageService.uploadDropboxUrl(uploadRequest,
                    res => {
                        that.close();
                        growl.success('Preparing to import from zip link', { ttl: 5000 });
                    },
                    err => {
                        that.close();
                        //growl.error('An error occurred while queueing the publish request', { ttl: 5000 });
                    });
            }

            that.isDisabled = function () {
                return that.isUploading === true;;
            }

            that.init();
        }]
});